module.exports = __webpack_public_path__ + "static/media/feature_7.a22fce2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/landing/feature_7.png
// module id = 1256
// module chunks = 0